<template>
  <div
    style="position: relative"
    :class="`rounded-${rounded}`"
    :style="{
      backgroundImage: `url(${cover})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }"
  >
    <v-skeleton-loader
      :class="`rounded-${rounded}`"
      type="image"
      :style="{
        backgroundColor: cover ? 'rgba(0, 0, 0, 0.4)' : undefined,
      }"
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
      "
    />
    <div
      ref="videoBackground"
      :data-vbg="src"
      :class="`rounded-${rounded}`"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
    ></div>
    <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import "youtube-background";

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    rounded: {
      type: String,
      default: "lg",
    },
    cover: {
      type: String,
      default: "cover",
    },
  },
  data() {
    return {
      videoBackgrounds: null,
    };
  },
  mounted() {
    this.videoBackgrounds = new window.VideoBackgrounds("[data-vbg]");
  },
  beforeDestroy() {
    this.videoBackgrounds?.destroy();
  },
};
</script>
